import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pointerPos: { x: null, y: null }
  },
  mutations: {
    setPos (state, pos) {
      state.pointerPos = pos
    }
  },
  actions: {
  },
  modules: {
  }
})
